/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { selectAllAssistantIds } from '@ibm-watson/shared/modules/ia/store/assistants/core-selectors';
import { ApiStatus } from '../../../../ts';
import { TaskListKey, TaskListPreferences } from '../../../../ts/preferences';
import { RootState } from '../../../../ts/state';
import { entityAdapter } from './adapter';

const selectors = entityAdapter.getSelectors(
  (state: RootState) => state.preferences
);

export const selectAllAssistantPreferences = selectors.selectAll;
export const selectAssistantPreferencesById = selectors.selectById;

export const selectBackgroundUrlPreference = (
  state: RootState,
  assistantId: string
) => {
  const prefs = selectAssistantPreferencesById(state, assistantId);
  return prefs?.preferences?.preview?.backgroundUrl;
};

export const selectTaskListStatusPreference = (
  state: RootState,
  assistantId: string
): TaskListPreferences => {
  const prefs = selectAssistantPreferencesById(state, assistantId);
  return prefs?.preferences?.taskListStatus || {};
};

export const selectWizardPreference = (
  state: RootState,
  assistantId: string
) => {
  const prefs = selectAssistantPreferencesById(state, assistantId);
  return prefs?.preferences?.personalizationWizard;
};

export const selectSeenOnboardingCongratsStatus = (state: RootState) => {
  const assistantIds = selectAllAssistantIds(state);
  return assistantIds.some(
    assistantId =>
      selectTaskListStatusPreference(state, assistantId)?.[
        TaskListKey.HAS_SEEN_ONBOARDING_CONGRATS_MODAL
      ]
  );
};

export const selectDashboardTaskListStatus = (state: RootState) => {
  const assistantIds = selectAllAssistantIds(state);
  return assistantIds.some(
    assistantId =>
      selectTaskListStatusPreference(state, assistantId)?.[
        TaskListKey.HAS_FINISHED_DASHBOARD_TASK_LIST
      ]
  );
};

export const selectIsPreferenceSetting = (state: RootState): boolean => {
  return state.preferences?.setAssistantPreferencesStatus === ApiStatus.LOADING;
};
